import {
  ActionList,
  Button,
  Text,
  Banner,
  LegacyStack,
  Card,
  FormLayout,
  InlineStack,
  LegacyCard,
  Layout,
  Page,
  Popover,
  Select,
  SkeletonBodyText,
  TextField,
} from "@shopify/polaris";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "./common/Axios";
import categoryJson0 from "../category-json/categories_0.json";
import useIsMobile from './useIsMobile';

import { toast } from "react-toastify";

export function Editprofile() {
  const domain = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Navigation hook
const isMobile = useIsMobile();

  const savedData = localStorage.getItem("storeData");
  const localData = savedData ? JSON.parse(savedData) : null;

  const userData = localData;
  const [is_variantions, setIsVariantions] = useState(1);
  const [saveButtonDisable, setSaveButtonDisable] = useState(false);

  const [itemCondition, setItemCondition] = useState([]);
  const [conditionOptions, setConditionOptions] = useState();
  const [selectedCondition, setSelectedCondition] = useState([]);
  const [productTypeCheck, setProductTypeCheck] = useState(false);
  const [productType, setProductType] = useState([]);
  const [productType1, setProductType1] = useState();

  const data = localData;
  const { id } = useParams();
  const [profileName, setProfileName] = useState("");
  const [profileName1, setProfileName1] = useState("");
  const [recommendedCheck, setRecommendedCheck] = useState(false);
  const [recommended, setRecommended] = useState([]);
  const [showSkelton, setShowSkelton] = useState(false);

  const [listingFormat, setListingFormat] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedDuration, setSelectedDuration] = useState("");
  const [itemLocation, setItemLocation] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [productIdType, setProductIdType] = useState("");
  const [productIdTypeMapping, setProductIdTypeMapping] = useState("");
  const [shippingProfiles, setShippingProfiles] = useState([
    { label: "Please add Shipping policy to your eBay account", value: "" },
  ]);
  const [paymentProfiles, setPaymentProfiles] = useState([
    { label: "Please add Payment policy to your eBay account", value: "" },
  ]);
  const [returnProfiles, setReturnProfiles] = useState([
    { label: "Please add Return policy to your eBay account", value: "" },
  ]);
  const [ebayProfile, setEbayProfile] = useState(false);
  const [popoverActive, setPopoverActive] = useState(null);
  const [noBusinessPolicies, setNoBusinessPolicies] = useState(false);
  const [profileData, setProfileData] = useState(false);
  const [selectedProfiles, setSelectedProfiles] = useState({
    Shipping: "",
    Payment: "",
    Return: "",
  });
  const [productTypeHeadOptions, setProductTypeHeadOptions] = useState([
    { label: "UPC", value: "UPC" },
    { label: "EAN", value: "EAN" },
    { label: "MPN", value: "MPN" },
    { label: "ISBN", value: "ISBN" },
  ]);
  const [variationSupported, setVariationSupported] = useState(true);
  const [ebay_category, setEbayCategory] = useState();
  const [ebay_category1, setEbayCategory1] = useState();

  const [categories, setCategories] = useState([]); // Full category data from API
  const [finalCategoryId, setFinalCategoryId] = useState(null); // Full category data from API
  const [selectedLevels, setSelectedLevels] = useState([]); // Selected categories
  const [categoryLevels, setCategoryLevels] = useState([]); // Stores options for each level
  const [categoryAvail, setCategoryAvail] = useState(false);
  const [ebayCatExisting, setEbayCatExisting] = useState("");
  const [selectedMethod, setSelectedMethod] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const handleChange = (key, value) => {
    setSelectedProfiles((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  console.log(selectedCondition);

  const togglePopover = (index) => {
    setPopoverActive(popoverActive === index ? null : index);
  };
  const handleProfileChange = (profileType, value) => {
    setSelectedProfiles((prev) => ({ ...prev, [profileType]: value }));
  };
  const handleAction = async (action, index) => {
    setPopoverActive(null);

    if (action === "Create") {
      const siteId = data?.user?.eb_key[0]?.siteid || 0;
      const ebayUrl = domainSite[siteId];

      const urls = [
        `${ebayUrl}/bp/ship/create`,
        `${ebayUrl}/bp/payment/create`,
        `${ebayUrl}/bp/rtn/create`,
      ];
      window.open(urls[index], "_blank");
    } else if (action === "Refresh") {
      try {
        const ebayProfilesResponse = await Axios.get(
          "/profile/refreshShoppingProfile",
        );
        const ebayProfilesData = ebayProfilesResponse.data;
        console.log(ebayProfilesData);

        if (index === 0 && ebayProfilesData.shipping_policies?.length) {
          setShippingProfiles([
            { label: "Select Shipping policy", value: "" },
            ...ebayProfilesData.shipping_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `shipping-${policy.ID}`,
            })),
          ]);
        } else if (index === 1 && ebayProfilesData.payment_policies?.length) {
          setPaymentProfiles([
            { label: "Select Payment policy", value: "" },
            ...ebayProfilesData.payment_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `payment-${policy.ID}`,
            })),
          ]);
        } else if (index === 2 && ebayProfilesData.return_policies?.length) {
          setReturnProfiles([
            { label: "Select Return policy", value: "" },
            ...ebayProfilesData.return_policies.map((policy) => ({
              label: policy.ProfileName,
              value: policy.ID.toString(),
              key: `return-${policy.ID}`,
            })),
          ]);
        }
      } catch (error) {
        console.error(
          `Error fetching ${["Shipping", "Payment", "Return"][index]} profiles:`,
          error,
        );
      }
    }
  };

  const recommendedOptions = [
    { label: "Set Ebay Recommended", value: "recommenedValue" },
    { label: "Set Custom Value", value: "customValue" },
    { label: "Set Shopify Attribute", value: "shopifyValue" },
  ];
  const listingOptions = [
    { label: "Select an option", value: "" },
    { label: "Fixed Price", value: "fixed_price" },
    { label: "Auction", value: "auction" },
  ];
  const fixedListingDuration = [
    { label: "Select an option", value: "" },
    { value: "GTC", label: "GTC" },
  ];
  const productTypeOptions = [
    { label: "SKU", value: "sku" },
    { label: "Barcode", value: "barcode" },
  ];
  const auctionListingDuration = [
    { label: "Select an option", value: "" },
    { value: "Days_3", label: "3 Days" },
    { value: "Days_5", label: "5 Days" },
    { value: "Days_7", label: "7 Days" },
    { value: "Days_10", label: "10 Days" },
  ];

  const domainSite = {
    0: "https://www.ebay.com",
    2: "https://www.ebay.ca",
    3: "https://www.ebay.co.uk",
    15: "https://www.ebay.com.au",
    16: "https://www.ebay.at",
    23: "https://www.befr.ebay.be",
    71: "https://www.ebay.fr",
    77: "https://www.ebay.de",
    100: "https://www.ebay.com",
    101: "https://www.ebay.it",
    123: "https://www.benl.ebay.be",
    146: "https://www.ebay.nl",
    186: "https://www.ebay.es",
    193: "https://www.ebay.ch",
    201: "https://www.ebay.com.hk",
    205: "https://www.ebay.ie",
    207: "https://www.ebay.com.my",
    210: "https://www.cafr.ebay.ca",
    211: "https://www.ebay.ph",
    212: "https://www.ebay.pl",
    216: "https://www.ebay.com.sg",
  };

  const countryList = [
    { label: "Select an option", value: "" },
    { label: "Azerbaijan", value: "AZ" },
    { label: "Australia", value: "AU" },
    { label: "Austria", value: "AT" },
    { label: "Belarus", value: "BY" },
    { label: "Belgium", value: "BE" },
    { label: "Bosnia and Herzegovina", value: "BA" },
    { label: "Botswana", value: "BW" },
    { label: "Brazil", value: "BR" },
    { label: "Canada", value: "CA" },
    { label: "Czech Republic", value: "CZ" },
    { label: "Denmark", value: "DK" },
    { label: "Finland", value: "FI" },
    { label: "France", value: "FR" },
    { label: "Georgia", value: "GE" },
    { label: "Germany", value: "DE" },
    { label: "Ireland", value: "IE" },
    { label: "Israel", value: "IL" },
    { label: "Italy", value: "IT" },
    { label: "Japan", value: "JP" },
    { label: "Jersey", value: "JE" },
    { label: "Lithuania", value: "LT" },
    { label: "Luxembourg", value: "LU" },
    { label: "Mexico", value: "MX" },
    { label: "Morocco", value: "MA" },
    { label: "Netherlands", value: "NL" },
    { label: "New Zealand", value: "NZ" },
    { label: "Norway", value: "NO" },
    { label: "Poland", value: "PL" },
    { label: "Portugal", value: "PT" },
    { label: "Saudi Arabia", value: "SA" },
    { label: "Singapore", value: "SG" },
    { label: "South Africa", value: "ZA" },
    { label: "Spain", value: "ES" },
    { label: "Sweden", value: "SE" },
    { label: "Switzerland", value: "CH" },
    { label: "Turkey", value: "TR" },
    { label: "United Arab Emirates", value: "AE" },
    { label: "United Kingdom", value: "GB" },
    { label: "United States", value: "US" },
  ];
  const shopifyAttributeOptions = [
    { label: "Vendor", value: "vendor" },
    { label: "Handle", value: "handle" },
    { label: "Product Type", value: "product_type" },
    { label: "Sku", value: "sku" },
    { label: "Barcode", value: "barcode" },
    { label: "Color", value: "color" },
    { label: "Title", value: "title" },
  ];
  const productIdTypeList = [
    { label: "Select an Option", value: "" },
    { value: "UPC", label: "UPC" },
    { value: "ISBN", label: "ISBN" },
    { value: "EAN", label: "EAN" },
    { value: "MPN", label: "MPN" },
  ];

  const productIdTypeMappingOptions = [
    { label: "Select an Option", value: "" },
    { value: "SKU", label: "SKU" },
    { value: "BARCODE", label: "BARCODE" },
  ];

  const handleListingFormatChange = (value) => {
    setListingFormat(value);
    setSelectedDuration("");
    setErrors((prevErrors) => ({ ...prevErrors, listingFormat: null }));
  };

  const handleDurationChange = (value) => {
    setSelectedDuration(value);
    setErrors((prevErrors) => ({ ...prevErrors, selectedDuration: null }));
  };

  useEffect(() => {
    let categoriesData;
    const fetchData = async () => {
      try {
        const [profileResponse] = await Promise.all([
          Axios.get(`/profiledata/${id}`),
        ]);
         try {
                 const siteId= localData.user.eb_key[0].siteid;
                const response = await fetch(
                    `https://cp2.infoshoreapps.com/api/public/category-json/categories_${siteId}.json`
                    );

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                 categoriesData = await response.json();
                // setCategories(data);
                setCategories(categoriesData);

                const topLevelCategories = Array.from(
                    new Set(
                    categoriesData.map(
                        (item) => item.category_tree_name.split(" > ")[0],
                    ),
                    ),
                ).map((category) => ({ label: category, value: category }));

                setCategoryLevels([topLevelCategories]);
                setSelectedLevels([""]);
                setCategoryAvail(true);
            } catch (error) {
            console.error("Error fetching the JSON:", error);
            }

        // // Handle Categories Data
        // const categoriesData = categoryJson0;
        // if (Array.isArray(categoriesData)) {
        //   setCategories(categoriesData);

        //   const topLevelCategories = Array.from(
        //     new Set(
        //       categoriesData.map(
        //         (item) => item.category_tree_name.split(" > ")[0],
        //       ),
        //     ),
        //   ).map((category) => ({ label: category, value: category }));
        //   setCategoryLevels([topLevelCategories]);
        //   setSelectedLevels([""]);
        //   setCategoryAvail(true);
        // }

        // Handle Profile Data
        const field = profileResponse.data.profile; // response.data is an object, not an array
        console.log(field);
        if (field) {
          if (field.item_condition_data) {
            const item_condition_data = JSON.parse(field.item_condition_data);
            const item_conditionSelected = JSON.parse(field.item_condition);
            console.log(item_conditionSelected);
            const conditionOptions1 = item_condition_data.map((cond) => ({
              label: cond.DisplayName,
              value: cond.ID,
            }));
            console.log(conditionOptions1);
            setConditionOptions(conditionOptions1);
            console.log(item_condition_data);

            setItemCondition(item_condition_data);
            setSelectedCondition(item_conditionSelected);
          }
          if (field.product_id_type) {
            const product_id_type = JSON.parse(field.product_id_type);
            console.log(product_id_type);
            setProductTypeCheck(true);

            productTypeOptions.forEach((item) => {
              console.log("item ", item);
              if (item.value == product_id_type.value) {
                setProductType(item.value);
              }
            });
            setProductType1(product_id_type.name);
          }
          if (field.category_attributes) {
            let categories_attributes = JSON.parse(field.category_attributes);
            setRecommendedCheck(true);
            console.log(categories_attributes);
            setRecommended(categories_attributes);
            const defaultMethod = {};
            const defaultValue = {};
            const item_specifics = JSON.parse(field.item_specifics);
            console.log(item_specifics);
            item_specifics.forEach((item) => {
              const [outerKey, innerObj] = Object.entries(item)[0];
              const innerKeys = Object.keys(innerObj);
              const firstInnerKey = innerKeys[0];
              if (firstInnerKey === "recommendation") {
                defaultMethod[outerKey] = "recommenedValue";
              }
              if (firstInnerKey === "custom") {
                defaultMethod[outerKey] = "customValue";
              }
              if (firstInnerKey === "shopify") {
                defaultMethod[outerKey] = "shopifyValue";
              }
              defaultValue[outerKey] = innerObj[firstInnerKey];
              console.log("Outer Key:", outerKey); // Color
              console.log("Inner Key:", firstInnerKey); // recommendation
              console.log("Inner Value:", innerObj[firstInnerKey]); // Beige
            });

            setSelectedMethod(defaultMethod);
            setSelectedValue(defaultValue);
          }

          setEbayCategory(field.ebay_category_id);
          setEbayCategory1(field.ebay_category_1);
          setProfileName1(field.name);
          setProfileName(field.name);
          setListingFormat(field.listing_format);
          setSelectedDuration(field.listing_duration);
          setItemLocation(field.item_location);
          setCountry(field.Country || "");
          setPostalCode(field.postal_code || "");
          setProductIdType(field.product_id_type || "");
          setProductIdTypeMapping("SKU");
          // setEbayCatExisting(field.ebay_category_1);
          // **Preselect the category from DB**
          if (field.ebay_category_1) {
            setFinalCategoryId(field.ebay_category_1);
            preselectCategory(field.ebay_category_1, categoriesData);
          }

          if (field.businessPolicies) {
            const ebayProfilesData = field.businessPolicies;
            let hasPaymentPolicies = false;
            let hasShippingPolicies = false;
            let hasReturnPolicies = false;

            // Process Payment Policies
            if (ebayProfilesData.payment_policies?.length) {
              const matchedProfile = ebayProfilesData.payment_policies.find(
                (policy) => policy.ID === field.payment_profile,
              );
              if (matchedProfile) {
                setSelectedProfiles((prev) => ({
                  ...prev,
                  Payment: matchedProfile.ID.toString(),
                }));
              }
              const payment = [
                { label: "Select Payment policy", value: "" },
                ...ebayProfilesData.payment_policies.map((policy) => ({
                  label: policy.ProfileName,
                  value: policy.ID.toString(),
                  key: `payment-${policy.ID}`,
                })),
              ];
              setPaymentProfiles(payment);
              hasPaymentPolicies = true;
            }

            // Process Shipping Policies
            if (ebayProfilesData.shipping_policies?.length) {
              const matchedProfile = ebayProfilesData.shipping_policies.find(
                (policy) => policy.ID === field.shipping_profile,
              );
              if (matchedProfile) {
                setSelectedProfiles((prev) => ({
                  ...prev,
                  Shipping: matchedProfile.ID.toString(),
                }));
              }
              const shipping = [
                { label: "Select Shipping policy", value: "" },
                ...ebayProfilesData.shipping_policies.map((policy) => ({
                  label: policy.ProfileName,
                  value: policy.ID.toString(),
                  key: `shipping-${policy.ID}`,
                })),
              ];
              setShippingProfiles(shipping);
              hasShippingPolicies = true;
            }

            // Process Return Policies
            if (ebayProfilesData.return_policies?.length) {
              const matchedProfile = ebayProfilesData.return_policies.find(
                (policy) => policy.ID === field.return_profile,
              );
              if (matchedProfile) {
                setSelectedProfiles((prev) => ({
                  ...prev,
                  Return: matchedProfile.ID.toString(),
                }));
              }
              const Return = [
                { label: "Select Return policy", value: "" },
                ...ebayProfilesData.return_policies.map((policy) => ({
                  label: policy.ProfileName,
                  value: policy.ID.toString(),
                  key: `return-${policy.ID}`,
                })),
              ];
              setReturnProfiles(Return);
              hasReturnPolicies = true;
            }

            setNoBusinessPolicies(
              !hasPaymentPolicies && !hasShippingPolicies && !hasReturnPolicies,
            );
            setEbayProfile(true);
          }
          setProfileData(true);

          // Now we need to fetch the category attributes of the selected ebay category
          // if(field.ebay_category_1){
          //     $ebayCat = field.ebay_category_1;
          //     axios.get(`/getebaycategorydetail/${$ebayCat}`)
          // }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setErrors({ fetch: "Failed to fetch data" });
      }
    };

    fetchData();
  }, [id]);

  const preselectCategory = (categoryId, categoriesData) => {
    // console.log("categoryId type:", typeof categoryId);
    // console.log("categoriesData first item id type:", typeof categoriesData[0]?.id);
    const matchedCategory = categoriesData.find(
      (cat) => Number(cat.id) === Number(categoryId),
    );

    if (!matchedCategory) return;
    console.log("this is the matchedCategory");
    const categoryPath = matchedCategory.category_tree_name.split(" > ");

    let newSelectedLevels = [];
    let newCategoryLevels = [];

    categoryPath.forEach((category, index) => {
      newSelectedLevels[index] = category;

      const newOptions = categoriesData
        .map((cat) => cat.category_tree_name.split(" > "))
        .filter((path) =>
          path
            .slice(0, index)
            .every((cat, idx) => cat === newSelectedLevels[idx]),
        )
        .map((path) => path[index])
        .filter(
          (value, i, self) => self.indexOf(value) === i && value !== undefined,
        );

      newCategoryLevels[index] = newOptions.map((cat) => ({
        label: cat,
        value: cat,
      }));
    });

    setSelectedLevels(newSelectedLevels);
    setCategoryLevels(newCategoryLevels);
  };

  const fetchItemCondition = async (categoryId) => {
    setSaveButtonDisable(true);
        setShowSkelton(true);
    setTimeout(() => {
      window.scrollTo(0, 500);
    }, 1000); 
    console.log("inside fetchitemcondition - ", categoryId);
    try {
      const response = await Axios.get("profile/fetchItemCondition", {
        params: {
          category_id: categoryId,
        },
      });
        setShowSkelton(false);
    setSaveButtonDisable(false);


      if (response && response.data.condition) {
        console.log(response.data);

        const freshCondition = response.data.condition;
        if (response.data.is_variantions === 0) {
          setIsVariantions(0);
          setVariationSupported(false);
        }

        // handle recommended
        const recommendedNew = JSON.stringify(response.data.recommended);

        if (Object.keys(response.data.recommended).length > 0) {
          console.log("inside of ' if (response.data.recommended.length > 0)'");
          setRecommendedCheck(true);
          setRecommended(response.data.recommended);
          const defaultMethod = {};
          const defaultValue = {};
          Object.entries(response.data.recommended).forEach(([key, values]) => {
            defaultMethod[key] = "recommenedValue";
            defaultValue[key] = values[0]; // First recommended value
          });
          setSelectedMethod(defaultMethod);
          setSelectedValue(defaultValue);
        } else {
          console.log(
            "inside of ' else (response.data.recommended.length > 0)'",
          );
          setRecommendedCheck(false);
          setRecommended([]);
        }
        //  handle product type here
        if (response.data.productTypeEnable === true) {
          setProductTypeCheck(true);
        } else {
          setProductTypeCheck(false);
        }
        if (response.data.productType) {
          setProductType1(response.data.productType);
        }
        if (response.data.ebay_category_id) {
          setEbayCategory(response.data.ebay_category_id);
        }
        setItemCondition(freshCondition); // updates state (async)
        const conditionOptions1 = freshCondition.map((cond) => ({
          label: cond.DisplayName,
          value: cond.ID,
        }));
        setConditionOptions(conditionOptions1);
        setSelectedCondition(conditionOptions1[0]);
        setProductType(productTypeOptions[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCategoryChange = (levelIndex, selectedValue) => {
    setProductTypeCheck(false);
    setVariationSupported(true);
    setItemCondition([]); // updates state (async)
    setRecommendedCheck(false);
    // Step 1: Update selected levels
    const newSelectedLevels = [...selectedLevels];
    newSelectedLevels[levelIndex] = selectedValue;
    newSelectedLevels.length = levelIndex + 1;
    setSelectedLevels(newSelectedLevels);

    // Step 2: Get next-level category options based on selected path
    const newOptions = categories
      .map((cat) => cat.category_tree_name.split(" > "))
      .filter((path) =>
        path
          .slice(0, levelIndex + 1)
          .every((cat, idx) => cat === newSelectedLevels[idx]),
      )
      .map((path) => path[levelIndex + 1])
      .filter(
        (value, index, self) =>
          self.indexOf(value) === index && value !== undefined,
      );

    const newCategoryLevels = [...categoryLevels];
    // ✅ Only add next level dropdown if options exist
    if (newOptions.length > 0) {
      newCategoryLevels[levelIndex + 1] = newOptions.map((category) => ({
        label: category,
        value: category,
      }));
    } else {
      newCategoryLevels.splice(levelIndex + 1); // 🔥 Removes extra dropdowns
    }
    setCategoryLevels(newCategoryLevels);

    // Step 3: Find and set the category ID
    const selectedPath = newSelectedLevels.join(" > ");
    const matchedCategory = categories.find(
      (cat) => cat.category_tree_name === selectedPath,
    );
    const categoryId = matchedCategory ? matchedCategory.id : null;
    setFinalCategoryId(categoryId);
    console.log("here is the last category ", categoryId);
    if (categoryId) {
      console.log("inside i fcondtion");
      console.log("inside i fcondtion");
      setEbayCategory1(categoryId);
      fetchItemCondition(categoryId);
    }

    setTimeout(() => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }, 100);

    // Step 4: If this is the last category, trigger API call
    // if (!newOptions.length && matchedCategory) {
    //     handleCategoryClick(matchedCategory, categoryId);
    // }
  };
  const handleChangeCondition = (value) => {
    const selected = conditionOptions.find((opt) => opt.value === value);
    setSelectedCondition(selected);
    console.log("Selected Condition:", selected); // { label: 'New', value: '1000' }
  };
  const handleChangeProductType = (value) => {
    const selected = productTypeOptions.find((opt) => opt.value === value);
    setProductType(selected);
    console.log("Selected Condition:", selected); // { label: 'New', value: '1000' }
  };
  const handleMethodChange = (key, method) => {
    setSelectedMethod((prev) => ({ ...prev, [key]: method }));

    if (method === "recommenedValue") {
      setSelectedValue((prev) => ({ ...prev, [key]: recommended[key][0] }));
    } else if (method === "shopifyValue") {
      setSelectedValue((prev) => ({
        ...prev,
        [key]: shopifyAttributeOptions[0].value,
      }));
    } else {
      setSelectedValue((prev) => ({ ...prev, [key]: "" }));
    }
  };

  const handleValueChange = (key, value) => {
    setSelectedValue((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const getFinalMappedValues = () => {
    const result = [];

    Object.keys(selectedValue).forEach((key) => {
      console.log(selectedMethod);
      let shouldScroll = false;

      console.log(selectedValue);
      const method = selectedMethod[key];
      const value = selectedValue[key];
      if (value === "") {
        errors.customValue = "Custom value is required.";
        shouldScroll = true;
        if (shouldScroll) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }

      if (!value) return; // skip empty

      if (method === "recommenedValue") {
        result.push({ [key]: { recommendation: value } });
      } else if (method === "customValue") {
        result.push({ [key]: { custom: value } });
      } else if (method === "shopifyValue") {
        result.push({ [key]: { shopify: value } });
      }
    });

    return result;
  };
  const validateForm = () => {
    let errors = {};
    let shouldScroll = false; // Flag to determine if we should scroll

    if (!profileName || profileName.trim() === "") {
      errors.profileName = "Profile Name is required";
      shouldScroll = true; // Mark scrolling needed
    }

    Object.keys(selectedValue).forEach((key) => {
      console.log(selectedMethod);

      console.log(selectedValue);
      const method = selectedMethod[key];
      const value = selectedValue[key];
      if (value === "") {
        errors.customValue = "Custom value is required.";
        shouldScroll = true;
      }
    });
    console.log(userData);

    const profileData = userData.user.profileData;

    console.log(profileData);
    const match = profileData.find(
      (item) => item.name === profileName && item.name !== profileName1,
    );

    if (match) {
      errors.profileName =
        "Profile name already taken, Please enter a new name.";
      shouldScroll = true;
    }

    // Business policies validation
    const policies = [
      {
        key: "Shipping",
        profile: shippingProfiles,
        message: "Please add Shipping policy to your eBay account",
      },
      {
        key: "Payment",
        profile: paymentProfiles,
        message: "Please add Payment policy to your eBay account",
      },
      {
        key: "Return",
        profile: returnProfiles,
        message: "Please add Return policy to your eBay account",
      },
    ];

    policies.forEach(({ key, profile, message }) => {
      if (profile[0]?.label !== message && !selectedProfiles[key]) {
        errors[key] = `Please select a ${key} policy`;
        shouldScroll = true;
      }
    });

    // Category validation (No scrolling for category errors)
    if (!finalCategoryId) {
      errors.category = "Please select all the category fields";
    }

    setErrors(errors);

    // Scroll to the top only if there are errors (excluding category)
    if (shouldScroll) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    return Object.keys(errors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) {
      return;
    }

    let mappedData = getFinalMappedValues();
    if (recommended.length === 0) {
      mappedData = [];
    }

    const productDateToSave = {
      id: id,
      name: profileName,
      businessPolicies: selectedProfiles,
      ebay_category_id: ebay_category,
      ebay_category_1: ebay_category1,
      item_condition: selectedCondition,
      item_condition_data: itemCondition,
      productType: { name: productType1, value: productType },
      is_variantions: is_variantions,
      item_specific: mappedData,
      category_attributes: recommended,
    };
    try {
      const response = await Axios.post("profile/updateProfile", {
        productDateToSave,
      });
      if (response.status === 200) {
        const savedData = localStorage.getItem("storeData");
        const localData = savedData ? JSON.parse(savedData) : null;
        if (localData && localData.user) {
          localData.user.profileData = response.data.profiles;
          localStorage.setItem("storeData", JSON.stringify(localData));
          toast.success("Profile Created Successfully.");
          console.log(`${domain}/profile`);
          navigate(`${domain}/profile`);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Layout>
      <Layout.Section>
        <Page fullWidth>
          <FormLayout>
            {profileData ? (
              <Card>
                <TextField
                  label="Profile Name"
                  value={profileName}
                     onChange={(value) => {
                  setProfileName(value);
                  if (errors.profileName) {
                    setErrors(prevErrors => ({ ...prevErrors, profileName: "" }));
                  }
                }}
                  error={errors.profileName}
                />
              </Card>
            ) : (
              <Card>
                <SkeletonBodyText lines={6} />
              </Card>
            )}

            <Card>
              <div style={{ marginBottom: "20px" }}>
                <Text variant="headingSm" as="h6">
                  Business Policies*
                </Text>
              </div>
              {isMobile ? (
                ebayProfile ? (
                <>
                  <div >
                    {["Shipping", "Payment", "Return"].map((profile, index) => (
                      <div
                        key={index}
                  
                      >
                        {/* Select Field with Fixed Width */}
                        <div >
                          <Select
                            label={`${profile} Profile`}
                            options={
                              profile === "Shipping"
                                ? shippingProfiles
                                : profile === "Payment"
                                  ? paymentProfiles
                                  : returnProfiles
                            }
                            value={selectedProfiles[profile]}
                            onChange={(value) =>
                              handleProfileChange(profile, value)
                            }
                            error={errors[profile]}
                          />
                        </div>

                        {/* Plus Button with Popover */}
                        <Popover
                          active={popoverActive === index}
                          activator={
                            <Button
                              size="slim"
                              onClick={() => togglePopover(index)}
                            >
                              +
                            </Button>
                          }
                          onClose={() => setPopoverActive(null)}
                        >
                          <ActionList
                            items={[
                              {
                                content: "Create",
                                onAction: () => handleAction("Create", index),
                              },
                              {
                                content: "Refresh",
                                onAction: () => handleAction("Refresh", index),
                              },
                            ]}
                          />
                        </Popover>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <SkeletonBodyText lines={8} />
                </>
              )
              ):(  
                ebayProfile ? (
                <>
                  <div style={{ display: "flex", gap: "16px" }}>
                    {["Shipping", "Payment", "Return"].map((profile, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: "8px",
                        }}
                      >
                        {/* Select Field with Fixed Width */}
                        <div style={{ width: "290px" }}>
                          <Select
                            label={`${profile} Profile`}
                            options={
                              profile === "Shipping"
                                ? shippingProfiles
                                : profile === "Payment"
                                  ? paymentProfiles
                                  : returnProfiles
                            }
                            value={selectedProfiles[profile]}
                            onChange={(value) => {
                                handleProfileChange(profile, value);
                                if (errors[profile]) {
                                  setErrors(prevErrors => ({ ...prevErrors, [profile]: "" }));
                                }
                              }}
                            error={errors[profile]}
                          />
                        </div>

                        {/* Plus Button with Popover */}
                        <Popover
                          active={popoverActive === index}
                          activator={
                            <Button
                              size="slim"
                              onClick={() => togglePopover(index)}
                            >
                              +
                            </Button>
                          }
                          onClose={() => setPopoverActive(null)}
                        >
                          <ActionList
                            items={[
                              {
                                content: "Create",
                                onAction: () => handleAction("Create", index),
                              },
                              {
                                content: "Refresh",
                                onAction: () => handleAction("Refresh", index),
                              },
                            ]}
                          />
                        </Popover>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <SkeletonBodyText lines={8} />
                </>
              ))}
         
            </Card>

            <Card>
              {categoryAvail ? (
                <>
                  <label>Select Category</label>
                  {categoryLevels.map((options, index) => {
                    const isLastSelect = index === categoryLevels.length - 1; // Check if this is the last select field

                    return (
                      <div key={index} style={{ marginBottom: "15px" }}>
                        {" "}
                        {/* Adds spacing */}
                        <Select
                          key={index}
                          value={selectedLevels[index] || ""}
                          onChange={(value) =>
                            handleCategoryChange(index, value)
                          }
                          options={[
                            { label: "Select Category", value: "" },
                            ...options,
                          ]}
                          error={isLastSelect ? errors.category : null} // Show error only on the last select
                        />
                      </div>
                    );
                  })}
                </>
              ) : (
                <SkeletonBodyText lines={4} />
              )}

              {!variationSupported && (
                <Banner
                  title="This Category is Variation Not Supported"
                  tone="critical"
                >
                  <p>
                    The selected eBay category does not support product
                    variations such as size or color options. If you want to
                    import a multi-variant product, please choose a different
                    category.
                  </p>
                </Banner>
              )}
            </Card>
            <>
                {showSkelton && (
                    <Card>
                        <LegacyCard subdued>
                                <LegacyCard.Section>
                                <SkeletonBodyText lines={2} />
                                </LegacyCard.Section>
                                <LegacyCard.Section>
                                <SkeletonBodyText lines={2} />
                                </LegacyCard.Section>
                            </LegacyCard>
                                <LegacyCard subdued>
                                <LegacyCard.Section>
                                <SkeletonBodyText lines={2} />
                                </LegacyCard.Section>
                                <LegacyCard.Section>
                                <SkeletonBodyText lines={2} />
                                </LegacyCard.Section>
                            </LegacyCard>
                    </Card>
                )}
              {itemCondition.length > 0 && (
                <div style={{ marginBottom: "20px" }}>
                  <Card>
                    <Select
                      label="Select Condition*"
                      options={conditionOptions}
                      onChange={handleChangeCondition}
                      value={selectedCondition?.value || ""}
                    />
                  </Card>
                </div>
              )}
              {productTypeCheck && (
                <div style={{ marginBottom: "20px" }}>
                  <Card>
                    <div style={{ marginBottom: "20px" }}>
                      <Text variant="headingSm" as="h6">
                        Product Listing Details*
                      </Text>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                      }}
                    >
                      <Select
                        label="Product Type"
                        options={productTypeHeadOptions}
                        onChange={(value) => setProductType1(value)}
                        value={productType1}
                      />
                      <Select
                        options={productTypeOptions}
                        onChange={(value) => setProductType(value)}
                        value={productType}
                      />
                    </div>
                  </Card>
                </div>
              )}
              {recommendedCheck && (
                <div style={{ marginBottom: "20px" }}>
                  <Card>
                    <div style={{ marginBottom: "20px" }}>
                      <Text variant="headingSm" as="h6">
                        Recommended Attribute Mapping*
                      </Text>
                    </div>

                    <LegacyStack vertical spacing="loose">
                      {Object.entries(recommended).map(([key, values]) => (
                        <div key={key} style={{ marginBottom: "30px" }}>
                          <Select
                            label={key}
                            options={recommendedOptions}
                            onChange={(value) => handleMethodChange(key, value)}
                            value={selectedMethod[key] || ""}
                          />

                          {selectedMethod[key] === "recommenedValue" && (
                            <div style={{ marginTop: "10px" }}>
                              <Select
                                options={values.map((val) => ({
                                  label: val,
                                  value: val,
                                }))}
                                onChange={(value) =>
                                  handleValueChange(key, value)
                                }
                                value={selectedValue[key] || ""}
                              />
                            </div>
                          )}

                          {selectedMethod[key] === "customValue" && (
                            <div style={{ marginTop: "10px" }}>
                              <TextField
                                placeholder="Enter Custom Value"
                                value={selectedValue[key] || ""}
                                onChange={(value) =>
                                  handleValueChange(key, value)
                                }
                                error={errors.customValue}
                              />
                            </div>
                          )}

                          {selectedMethod[key] === "shopifyValue" && (
                            <div style={{ marginTop: "10px" }}>
                              <Select
                                options={shopifyAttributeOptions}
                                onChange={(value) =>
                                  handleValueChange(key, value)
                                }
                                value={selectedValue[key] || ""}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </LegacyStack>
                  </Card>
                </div>
              )}
            </>

            <div  style={{width:'300px',margin:'auto'}}>
              <Button
                submit
                disabled={saveButtonDisable}
                size="large"
                fullWidth={true}
                variant="primary"
                onClick={() => {
                  handleUpdate();
                }}
              >
                Update
              </Button>
            </div>
          </FormLayout>
        </Page>
      </Layout.Section>
    </Layout>
  );
}
